module.exports = __webpack_public_path__ + "c80531aebf009319e55c74d06a4f5d39.png";